import { api } from "../../../config/api";
import { BillingFormData } from "../../../pages/BillingAddress";
import { GSTFormData } from "../../../pages/GstInvoice";
import { ProfileShipmentData } from "./AddProfileModal";

export interface CustomerDetailsType {
  id: number;
  person_name: string;
  mobile_numebr: string;
  email: string;
  address: string;
  order_channel: string;
}

export const getCustomerApi = () => {
  return api.get("/b2c/customer_list/");
};

export const getCustomerDetailsApi = (mobile_number: string) => {
  return api.get("/b2c/customer_list_details/", {
    params: {
      mobile_number,
    },
  });
};
export const getShipmentProfilesApi = () => {
  return api.get("/b2c/shipment_profiles/");
};

export const postShipmentProfilesApi = (data: ProfileShipmentData) => {
  return api.post("/b2c/shipment_profiles/", data);
};

// apis for service
export interface ServiceDetailsType {
  service_name: string;
  id: number;
  service_id: string;
  POD: string;
  tracking_service: string;
  activated_on: string;
  delivery_boy_number: string;
  is_active: boolean;
}

export const getServicerApi = (status: string) => {
  return api.get("/b2c/service_list/", {
    params: {
      status,
    },
  });
};

export const changeServicApi = ({
  status,
  service_id,
}: {
  status: string;
  service_id: string;
}) => {
  return api.post(
    `/b2c/service_list/?status=${status}&service_id=${service_id}`
  );
};

export const getBillingAddres = () => {
  return api.get("/bidsite/user_billing_address/");
};
export const submitBillingAddres = (data: BillingFormData) => {
  return api.post("/bidsite/user_billing_address/", data);
};
export const updateBillingAddres = (data: BillingFormData) => {
  return api.put("/bidsite/user_billing_address/", data);
};
export const getGstDetails = () => {
  return api.get("/bidsite/user_gst_detail/");
};
export const submitGstDetails = (data: GSTFormData) => {
  return api.post("/bidsite/user_gst_detail/", data);
};
export const updateGstDetails = (data: GSTFormData) => {
  return api.put("/bidsite/user_gst_detail/", data);
};
